import React, { useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { parse } from 'query-string';
import isEmpty from 'lodash/isEmpty';
import { camelizeKeys } from 'humps';
import { Button, Container, Col, Row, Jumbotron } from 'reactstrap';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import config from '../../../config';
import { useTransportationJson, createDataForInvoice } from '../Common';
import TransportationSearchFormWrapper from '../Common/TransportationSearchFormWrapper';
import { createInvoice } from '../../../services/cart';
import {
  SemiTransparentLoader,
  FeaturedTransportSlider,
  WhitePanel,
  FullReview,
  JumbotronImageSlider as Slider,
} from '../../../components';
import TransportDateAndPaxForm from './TransportDateAndPaxForm';
import { getCustomToast } from '../../../components/ErrorMessage';

import reviews from '../TransportationSearch/transportationReviews.json';

// import FromTo from '../TransportationList/FromTo';
// import { getPeopleNumStr } from '../TransportationList/TransportationCard';

const GalleryArrow = ({ onClick, direction }) => (
  <div className={`control ${direction}`}>
    <a role="button" onClick={onClick}>
      <div className="circle">
        <i className={`icon icon-hg-chev-${direction}`} />
      </div>
    </a>
  </div>
);

const settings = {
  infinite: true,
  slidesToScroll: 1,
  autoplay: true,
  swipe: true,
  dots: false,
  nextArrow: <GalleryArrow direction="right" />,
  prevArrow: <GalleryArrow direction="left" />,
  speed: 1500,
  centerPadding: '20px',
  rows: 1,
};

function TransportaionDetails({ history }) {
  const [isLoading, setIsLoading] = useState();
  const { location: { search } } = history;
  const queryParams = camelizeKeys(parse(search));
  const { id, fromLocation, toLocation, pax, tripType, departureDate } = queryParams;
  const transportaionData = useTransportationJson();
  const data = transportaionData ? transportaionData.filter(t => t.id === id) : null;
  if (!data) return <SemiTransparentLoader isLoading={true} />;
  const {
    mode,
    sectors,
    phoneNumbers,
    price,
    capacity,
    departureTime,
    arrivalTime,
    duration,
    inclusions,
    departFrom,
    coverImages,
    notes,
    returnDepartureTime,
    returnArrivalTime,
    returnDuration,
    // distance,
    // vehicleType,
  } = data[0];
  const [from] = sectors;
  const { amount, currency } = price;
  const isPrivate = mode.toLowerCase() === 'private';
  const isRoundTrip = tripType.toLowerCase() === 'r';
  // const tripTypeTitle = isRoundTrip ? 'Round Trip' : 'One Way';
  let totalPrice = isPrivate ? amount : Number(amount) * Number(pax);
  totalPrice = isRoundTrip ? totalPrice * 2 : totalPrice;

  const departureDuration = from === fromLocation ? duration : (returnDuration || duration);
  const arrivalDuration = from === fromLocation ? (returnDuration || duration) : duration;

  const thumbnail = (i) => <img src={`${config.ASSETS_URL}${coverImages}`} alt="" />;

  const handleClick = async () => {

    if (!departureDate) {
      getCustomToast(
        'Please enter your booking dates.', 'error'
      );

      const form = document.getElementById('transport-booking-form-2');

      // return window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      return form.scrollIntoView();
    }

    const isPaxExceedsCapacity = isPrivate && Number(pax) > Number(capacity);
    if (isPaxExceedsCapacity) {
      getCustomToast(
        'Sorry, the number of passengers exceeds the capacity of this vehicle.',
        'error'
      );
      return;
    }
    setIsLoading(true);
    try {
      const invoiceId = await createInvoice(createDataForInvoice(data[0], queryParams));
      history.push(`payment/${invoiceId}`);
    } catch (err) {
      getCustomToast('Some problem occured. Please try again', 'error');
      setIsLoading(false);
    }
  };

  const SubTotalPrice = () => {
    if (isRoundTrip) {
      return (totalPrice / 2);
    } else {
      return totalPrice;
    }
  }

  const renderRoundTripPickupPoints = () => {
    if (!isRoundTrip) return null;
    return (
      <div className="transport-detail-card">
        <h4>{toLocation} ➤ {fromLocation}</h4>
        {(fromLocation === from) ? (
          <Fragment>
            <div className="time-price">
              <div className="time-price-item">
                <h6>Departure Time</h6>
                <p>{returnDepartureTime || departureTime}</p>
              </div>
              <div className="time-price-item">
                <h6>Arrival Time</h6>
                <p>{returnArrivalTime || arrivalTime}</p>
              </div>
              <div className="time-price-item">
                <h6>Duration</h6>
                <p>{arrivalDuration}</p>
              </div>
              <div className="time-price-item">
                <h6>Price</h6>
                <p style={{ color: '#e91e63' }}>{currency} {SubTotalPrice().toLocaleString()}</p>
              </div>
            </div>
            <p>Pickup point: {departFrom && `${departFrom[sectors[1]]}, `} {toLocation}</p>
            <p>Drop off point: {departFrom && `${departFrom[sectors[0]]}, `}{fromLocation} </p>
          </Fragment>
        ) : (
            <Fragment>
              <div className="time-price">
                <div className="time-price-item">
                  <h6>Departure Time</h6>
                  <p>{departureTime}</p>
                </div>
                <div className="time-price-item">
                  <h6>Arrival Time</h6>
                  <p>{arrivalTime}</p>
                </div>
                <div className="time-price-item">
                  <h6>Duration</h6>
                  <p>{departureDuration}</p>
                </div>
                <div className="time-price-item">
                  <h6>Price</h6>
                  <p style={{ color: '#e91e63' }}>{currency} {SubTotalPrice().toLocaleString()}</p>
                </div>
              </div>
              <p>Pickup point: {departFrom[sectors[0]]}, {toLocation} </p>
              <p>Drop off point: {departFrom[sectors[1]]}, {fromLocation}</p>
            </Fragment>
          )}
      </div>
    );
  };

  const renderPickupPoints = () => {
    return (
      <div className="transport-detail-card">
        <h4>{fromLocation} ➤ {toLocation} </h4>
        {(fromLocation === from) ? (
          <Fragment>
            <div className="time-price">
              <div className="time-price-item">
                <h6>Departure Time</h6>
                <p>{departureTime}</p>
              </div>
              <div className="time-price-item">
                <h6>Arrival Time</h6>
                <p>{arrivalTime}</p>
              </div>
              <div className="time-price-item">
                <h6>Duration</h6>
                <p>{departureDuration}</p>
              </div>
              <div className="time-price-item">
                <h6>Price</h6>
                <p style={{ color: '#e91e63' }}>{currency} {SubTotalPrice().toLocaleString()}</p>
              </div>
            </div>
            <p>Pickup point: {departFrom && `${departFrom[sectors[0]]}, `}{fromLocation}</p>
            <p>Drop off point: {departFrom && `${departFrom[sectors[1]]}, `}{toLocation} </p>
          </Fragment>
        ) : (
            <Fragment>
              <div className="time-price">
                <div className="time-price-item">
                  <h6>Departure Time</h6>
                  <p>{returnDepartureTime}</p>
                </div>
                <div className="time-price-item">
                  <h6>Arrival Time</h6>
                  <p>{returnArrivalTime}</p>
                </div>
                <div className="time-price-item">
                  <h6>Duration</h6>
                  <p>{arrivalDuration}</p>
                </div>
                <div className="time-price-item">
                  <h6>Price</h6>
                  <p style={{ color: '#e91e63' }}>{currency} {SubTotalPrice().toLocaleString()}</p>
                </div>
              </div>
              <p>Pickup point: {departFrom && `${departFrom[sectors[1]]}, `}{fromLocation}</p>
              <p>Drop off point: {departFrom && `${departFrom[sectors[0]]}, `}{toLocation}</p>
            </Fragment>
          )}
      </div>
    );
  };

  return (
    <Container>
      <Row>
        <Col lg="3">
          <TransportationSearchFormWrapper forMobile />
          <TransportationSearchFormWrapper />
        </Col>
        <Col lg="9">
          <div className="transport-detail-info">
            <div className="transport-info">
              <h1>{fromLocation} to {toLocation}</h1>
            </div>
            <div className="transport-action">
              <Button color="yellow" id="transport-select-btn" onClick={handleClick} disabled={isLoading}>
                Book Now
          </Button>
            </div>
          </div>

          <Jumbotron className="transport-image">
            <Slider
              showNav
              {...settings}
              customPaging={thumbnail}
              images={[`${config.ASSETS_URL}${coverImages}`, `${config.ASSETS_URL}${coverImages}`]}
            />
          </Jumbotron>
          <TransportDateAndPaxForm />

          <WhitePanel className="transport-additional-info">
            <div className="title-box">
              <h2>Additional Information</h2>
              <Button color="yellow" id="transport-select-btn" onClick={handleClick} disabled={isLoading} className="d-none d-md-block">Book Now</Button>
            </div>
            <div className="d-flex justify-content-between">
              <ul>
                <li>Transportation Mode: {mode}</li>
                <li>{!isEmpty(inclusions) && `Included Services: ${inclusions.join(', ')}`}</li>
                {phoneNumbers && <li>Mobile Number: {phoneNumbers.join(',')}</li>}
              </ul>
              <div className="d-none d-md-block">
                <h3>Total Price</h3>
                <p style={{ color: '#e91e63', fontWeight: '600' }}>{currency} {totalPrice.toLocaleString()}</p>
              </div>
            </div>
            <h3>Detailed Schedule</h3>
            {renderPickupPoints()}
            {renderRoundTripPickupPoints()}
          </WhitePanel>

          {notes && (
            <WhitePanel>
              <h2>Notes*</h2>
              <p>{notes}</p>
            </WhitePanel>
          )}

          <div className="othe-cards">
            <FeaturedTransportSlider dataKey="KTMRHP" />
          </div>
          <FullReview reviews={reviews} type="flight" sectionId="fullReviewsSection" />
          <FullReview reviews={reviews} type="flight" isMobile sectionId="fullReviewsSection" />
        </Col>
      </Row>
    </Container>
  );
};

export default withRouter(TransportaionDetails);


// WEBPACK FOOTER //
// ./src/screens/Transportation/TransportationDetails/TransportationDetails.js